"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 所有坐标系的基类
 */
var Coordinate = /** @class */ (function () {
    /**
     * @contructor
     * @param ctx 全局上下文
     * @param model 数据模型
     */
    function Coordinate(ctx, helpers) {
        this.ctx = ctx;
        this.helpers = helpers;
    }
    return Coordinate;
}());
exports.Coordinate = Coordinate;
//# sourceMappingURL=coordinate.js.map